/**
 * Created by renatolovizotto on 01/08/17.
 */
import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import '../../assets/stylesheets/Game.scss';
import GameStep1 from './GameStep1';
import GameStep2 from './GameStep2';
import GameStep3 from './GameStep3';
import GameStep4 from './GameStep4';
import GameStep5 from './GameStep5';
import Modal from 'react-modal';

@inject('AuthStore', 'SchoolStore', 'GameStore','Navigator')
@observer
export default class Game extends Component {

    constructor(props) {
        super(props);

        this.state = {
            step: 1,
            navButtonLabels: [
                "Number of Teams",
                "Participant's Levels",
                "Start Game",
                "Next Question",
                "Continue Lesson"
            ],
            gameSteps: [
                <GameStep1/>,
                <GameStep2/>,
                <GameStep3/>,
                <GameStep4/>,
                <GameStep5/>
            ]
        };

        // Prevent unnecessary render
        this.teamAnswer = null;
    }

    componentDidMount() {
        this.props.GameStore.loadQuestions();
    }

    handleNextStep() {

        if (this.teamAnswer) {
            const player = this.props.GameStore.players.find(p => p.name === this.teamAnswer.player.name);
            player.score += this.props.GameStore.answers[this.teamAnswer.index].points;
            this.teamAnswer = null;
            this._setWinners();
        }

        if (this.state.step === 5) {
            this.props.GameStore.resetGame();
            this.props.Navigator.push("/games");
            return;
        }

        if (this.props.GameStore.players.length === this.props.GameStore.alreadyPlayed.length) {
            this.props.GameStore.alreadyPlayed = [];
        }

        if (this.state.step === 4
            && !(this.props.GameStore.round === (this.props.GameStore.numberRounds * this.props.GameStore.players.length))) {
            this.props.GameStore.round += 1;
            return;
        }

        this.setState(
            prevState => {
                return {
                    step: prevState.step + 1
                }
            }
        )
    }

    _setWinners() {
        const playerOrdered = this.props.GameStore.players.sort((a, b) => {
            return a.score < b.score;
        });

        let winners = [];
        let highScore = playerOrdered[0].score; // Gets the high score

        // Discover tie winners
        for (let w of playerOrdered) {
            if (w.score === highScore) {
                winners = [...winners, w];
            }
        }

        this.props.GameStore.winners = winners;
    }

    handleChangeAnswer({player, index}) {
        this.teamAnswer = {player, index};
    }

    handleClose() {
        this.props.Navigator.push("/games")
    }

    openModal() {
        this.setState({modalIsOpen: true});
    }

    closeModal() {
        this.setState({modalIsOpen: false});
    }

    render() {

        const {
            step,
            gameSteps,
            navButtonLabels,
        } = this.state;

        const {
            players
        } = this.props.GameStore;

        let cantGoNextStep = false;
        if (step === 3) {
            cantGoNextStep = players.find(p => p.levels.length === 0);
        }

        if (step === 4) {
            cantGoNextStep = true;
        }

        const customStyles = {
            overlay : {
                position          : 'fixed',
                top               : 0,
                left              : 0,
                right             : 0,
                bottom            : 0,
                backgroundColor   : 'black'
            },
            content : {
                top                   : '50%',
                left                  : '50%',
                right                 : 'auto',
                bottom                : 'auto',
                marginRight           : '-50%',
                transform             : 'translate(-50%, -50%)',
                background            : 'black',
                color                 : 'white'
            }
        };

        return (
            <div className="Game Page">
                <Modal
                    isOpen={this.state.modalIsOpen}
                    style={customStyles}
                    contentLabel="Modal"
                >
                    <h1>Would you like to leave the game?</h1>
                    <button className="btn-modal"
                        onClick={this.handleClose.bind(this)}>YES
                    </button>
                    <button className="btn-modal right"
                        onClick={this.closeModal.bind(this)}>NO
                    </button>
                </Modal>
                <div className="Close">
                    <button className="btn-close"
                        onClick={this.openModal.bind(this)}>X
                    </button>
                </div>
                {step !== 4
                    ? gameSteps[step - 1]
                    : <GameStep4 onChangeAnswer={this.handleChangeAnswer.bind(this)}/>
                }
                <div className="nav">
                    <button
                        className={"btn-nav-next" + ((step === 2 && players.length === 0) || cantGoNextStep ?  " disabled": "")}
                        onClick={this.handleNextStep.bind(this)}>{navButtonLabels[step - 1]}</button>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/Game/Game.js